<section class="mt-5">
  <nz-card>


    <div *ngIf="typeName === 'user-profile-view'">
      <div class="flex flex-row justify-between items-start">
        <div class="grid grid-cols-2 items-center gap-4">
          <nz-space nzSize="middle">
            <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
          </nz-space>
          <div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 2 }" [nzActive]="true"></nz-skeleton>
          </div>
        </div>
        <nz-space nzSize="middle">
          <nz-skeleton-element *nzSpaceItem nzType="button" [nzShape]="'round'" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
      </div>
      <div class="mt-5">
        <nz-skeleton [nzParagraph]="{ rows: 4 }" [nzActive]="true"></nz-skeleton>
      </div>
      <div class="mt-5">
        <nz-skeleton [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
      </div>
    </div>


    <div *ngIf="typeName === 'single-view' || typeName === 'single-fleet-view'">
      <div class="flex justify-end">

      </div>
      <div class="mt-5">
        <div class="flex flex-row justify-between items-center gap-2">
          <!--        <nz-space nzSize="middle">-->
          <!--        <nz-skeleton-element *nzSpaceItem nzType="input" nzshape="circle" [nzSize]="'default'" style="width:800px"></nz-skeleton-element>-->
          <!--        </nz-space>-->
          <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
          <nz-space nzSize="middle">
            <nz-skeleton-element *nzSpaceItem nzType="button" [nzShape]="'round'"
                                 [nzActive]="true"></nz-skeleton-element>
          </nz-space>
        </div>
        <div *ngIf="typeName === 'single-fleet-view'">
          <div class="grid md:grid-cols-4 gap-5">
            <nz-space nzSize="middle">
              <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
            </nz-space>
            <nz-space nzSize="middle">
              <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
            </nz-space>
            <nz-space class="hidden md:block" nzSize="middle">
              <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
            </nz-space>
            <nz-space class="hidden md:block" nzSize="middle">
              <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
            </nz-space>
          </div>
        </div>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
        </div>
      </div>

      <div class="mt-5">
        <div class="flex justify-between gap-2 flex-col md:flex-row">
          <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        </div>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
        </div>
      </div>

      <div class="mt-5">
        <div class="flex justify-between gap-2 flex-col md:flex-row">
          <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        </div>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
          <div class="flex flex-row my-3">
            <div class="w-1 bg-primary mr-4"></div>
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 5 }" [nzActive]="true"></nz-skeleton>
          </div>
        </div>
      </div>
    </div>


    <div *ngIf="typeName === 'driver-single-view-vehicle-tab'">
      <div class="hidden md:grid md:grid-cols-6">
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
      </div>
      <div class="grid md:grid-cols-6">
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        <nz-space nzSize="middle">
          <nz-skeleton-element *nzSpaceItem nzType="button" [nzShape]="'round'"></nz-skeleton-element>
        </nz-space>
      </div>
      <div class="grid md:grid-cols-6 mt-3">
        <nz-space nzSize="middle">
          <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
        <nz-space nzSize="middle">
          <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
        <nz-space nzSize="middle">
          <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
        <nz-space nzSize="middle">
          <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
        <nz-space nzSize="middle">
          <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
        <nz-space nzSize="middle">
          <nz-skeleton-element nzType="image" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
      </div>
    </div>


    <div *ngIf="typeName === 'note-view'" class="mt-5">
      <div class="grid md:grid-cols-2 gap-5">
        <nz-skeleton [nzParagraph]="{ rows: 6 }" [nzActive]="true"></nz-skeleton>
        <nz-skeleton [nzParagraph]="{ rows: 6 }" [nzActive]="true"></nz-skeleton>
      </div>
    </div>


    <div *ngIf="typeName === 'report'" class="mt-5">
      <div class="grid md:grid-cols-2">
        <div>
          <nz-skeleton [nzTitle]="true" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
          <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
          <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
          <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
          <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
        </div>
      </div>
    </div>

    <div *ngIf="typeName === 'cost-detail'" class="mt-5">

      <nz-skeleton [nzParagraph]="{ rows: 6 }" [nzActive]="true"></nz-skeleton>
      <div class="table-card mt-3">
        <div class="table-obj">
          <nz-table #basicTable
                    [nzData]="dummyData"
                    [nzShowSizeChanger]="true"
                    [nzPageSize]="5"
                    [nzPageIndex]="0" [nzFrontPagination]="false" [nzTotal]="5"
                    nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }">
            <thead>
<!--            <tr>-->
<!--              <th style="white-space: nowrap;" *ngFor="let column of dummyData">{{column}}</th>-->
<!--            </tr>-->
            </thead>
            <tbody>
            <tr *ngFor="let data of basicTable.data">
              <td style="white-space: nowrap;" *ngFor="let column of dummyData">
                <nz-skeleton class="" [nzTitle]="false" [nzActive]="true" [nzParagraph]="{ rows: 1 }"></nz-skeleton>
              </td>
            </tr>
            </tbody>
          </nz-table>
        </div>
      </div>

    </div>

  </nz-card>
</section>
